import React from 'react'
import { Button, Form } from 'react-bootstrap'

const SourceForm = ({ handleChange, sourceForm, handleSubmit, handleCancel }) => {
    return (
        <>
            <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                    <Form.Label>Source Name<span className="text-danger">*</span></Form.Label>
                    <Form.Control
                        type="text"
                        name="title"
                        value={sourceForm.title}
                        onChange={handleChange}
                        required
                    />
                </Form.Group>
                <div className="d-flex justify-content-end gap-2">
                    <Button variant="secondary" onClick={handleCancel}>
                        Cancel
                    </Button>
                    <Button type="submit" variant="primary">
                        {sourceForm.id ?'Update':'Submit'}
                    </Button>
                </div>
            </Form>

        </>
    )
}

export default SourceForm
